import {Col, Container, Modal, Row} from "react-bootstrap";
import React, {useContext, useEffect, useState} from "react";
import {formatCurrency, handleDefaultValues} from "../common/Utils";
import {useForm} from 'react-hook-form';
import MDButton from "../../components/MDButton";
import MDInput from "../../components/MDInput";
import {Chip, Divider, FormControlLabel, IconButton, InputAdornment, NativeSelect} from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import {AppContext} from "../../lib/AppContext";
import {CONSTANTS} from "../common/constants";
import {
  getBrands,
  getEventPackageInventories,
  getInventoryEventTypes,
  getInventoryTypes
} from "../common/api/InventoryApi";
import Avatar from "@mui/material/Avatar";
import Icon from "@mui/material/Icon";

export default function ManageEventTypePackageModal({eventPackage, show, handleSave, handleClose, saving}) {

  const [context, setContext] = useContext(AppContext);
  const [inventory, setInventory] = useState(eventPackage?.inventory);
  const isInventoryEvent = false;

  const [unlimited, setUnlimited] = useState(false);
  const giftCard = false;
  const inventoryLabel = 'Event Package';
  const [isNew, setIsNew] = useState(!eventPackage?.inventory?.guid);

  const [inventoryTypes, setInventoryTypes] = useState();
  const [eventTypes, setEventTypes] = useState([]);
  const [brands, setBrands] = useState();

  const statuses = [...CONSTANTS.STATUS_TYPES];

  const [inventoryImage, setInventoryImage] = useState(null);
  const [inventoryImageName, setInventoryImageName] = useState(null);
  const [inventoryImageType, setInventoryImageType] = useState(null);
  const [validImageSize, setValidImageSize] = useState(true);
  const [imageSize, setImageSize] = useState(0);
  const [removeImage, setRemoveImage] = useState(false);
  const [removeIndex, setRemoveIndex] = useState(1);
  const [price, setPrice] = useState(eventPackage?.inventory?.price);
  const [minAmount, setMinAmount] = useState(eventPackage?.inventory?.minAmount);
  const [maxAmount, setMaxAmount] = useState(eventPackage?.inventory?.maxAmount);

  const [wholesalePrice, setWholesalePrice] = useState(eventPackage?.inventory?.wholesalePrice);

  const [preview, setPreview] = useState(null);
  const [formInvalid, setFormInvalid] = useState(false);


  const [availableInventories, setAvailableInventories] = useState([]);
  const [assignedInventories, setAssignedInventories] = useState([]);
  const [packagePrice, setPackagePrice] = useState(0);

  const toggleUnlimited = (e) => {
    setUnlimited(e.target.checked);
  };

  useEffect(() => {
    getInventoryTypes().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        let _none = {id: null, name: 'None'};
        let _types = [_none, ...result];
        setInventoryTypes(result);
      }
    });
    getInventoryEventTypes().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setEventTypes(result);
      }
    });
    getBrands().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        let _none = {id: -1, name: 'None'};
        let _brands = [_none, ...result];
        setBrands(_brands);
      }
    });

  }, [show]);

  useEffect(() => {
    setInventory(eventPackage?.inventory);
    setAssignedInventories(eventPackage?.assignedInventories);
  }, [eventPackage?.inventory]);

  const {register, handleSubmit, setValue, control} = useForm({
    values: handleDefaultValues(inventory)
  });

  const handleSaveFn = (data) => {
    let d = {...data};
    d.price = price;
    d.wholesalePrice = wholesalePrice;
    d.unlimited = unlimited;
    d.giftCard = giftCard;
    d.minAmount = minAmount;
    d.maxAmount = maxAmount;
    d.inventoryImage = inventoryImage;
    d.inventoryImageName = inventoryImageName;
    d.inventoryImageType = inventoryImageType;
    d.removeImage = removeImage;

    let eventPackage = {
      inventory: d,
      assignedInventories: assignedInventories
    }
    handleSave(eventPackage);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) {
      setPreview(null);

      setInventoryImageName(null);
      setInventoryImageType(null);
      setInventoryImage(null);
      setValidImageSize(true);
      setImageSize(0);
      return;
    }
    setRemoveImage(false);
    setInventoryImageName(file.name);
    setInventoryImageType(file.type);
    setValidImageSize(true);

    const reader = new FileReader();

    reader.onload = function (evt) {
      setImageSize(file.size);
      setValidImageSize((file.size / 1e6).toFixed(1) < 5);
      setInventoryImage(btoa(evt.target.result));
    }
    reader.readAsBinaryString(file);
    setPreview(URL.createObjectURL(file));

    setRemoveImage(false);
  }

  const removePreviewImage = () => {
    setRemoveImage(true);
    setImageSize(0);
    setInventoryImage(null);
    setValidImageSize(true);
    setPreview(null);
  }

  useEffect(() => {
    getEventPackageInventories(eventPackage).then((resp) => {
      setAvailableInventories(resp);
    });
  }, [])

  const assignInventory = (inventory) => {
    let _assignedInventories = assignedInventories ? [...assignedInventories] : [];
    let hasItem = false;
    for (let j in _assignedInventories) {
      if (_assignedInventories[j].id === inventory.id) {
        hasItem = true;
      }
    }
    if (hasItem) {
      return;
    }
    _assignedInventories.push(inventory);
    setAssignedInventories(_assignedInventories);
  }

  const updateItem = (item, checked) => {
    let _assignedInventories = [...assignedInventories];
    item.included = checked;

    for (let j in _assignedInventories) {
      if (_assignedInventories[j].id === item.id) {
        _assignedInventories[j].included = checked;
      }
    }

    let itemsPrice = 0;
    for (let j in _assignedInventories) {
      if (_assignedInventories[j].included) {
        itemsPrice += parseFloat(_assignedInventories[j].wholesalePrice);
      }
    }
    setPackagePrice(itemsPrice)
    setAssignedInventories(_assignedInventories);
  }

  const handleRemoveItem = (item) => {
    let idx;
    let _assignedInventories = [...assignedInventories];
    for (let j in _assignedInventories) {
      if (_assignedInventories[j].id == item.id) {
        idx = j;
        break;
      }
    }

    _assignedInventories.splice(idx, 1);
    setAssignedInventories(_assignedInventories);
  }

  const getChecked = (inventory) => {
    if (inventory?.included) {
      return true;
    }
    return false;
  }

  return (
    <>
      <Modal onHide={handleClose} size={'lg'} show={show}>
        <form onSubmit={handleSubmit(handleSaveFn)} id={'inventoryForm'}>
          <Modal.Header closeButton>
            <Modal.Title>{isNew ? 'Create New' : 'Manage'} {inventoryLabel}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col className={'col col-main'} xs={12}>
                <Container>
                  <Row>
                    <Col className={'col'} sm={12} xs={12}>
                      <div className="form-group">
                        <MDInput type="text" required
                                 {...register('name')}
                                 autoComplete="off"
                                 className="form-control" id="name"
                                 label={'Enter ' + inventoryLabel + ' Name'}/>
                      </div>
                    </Col>
                  </Row>

                  {giftCard && <>
                    <Row className={'mt-4'}>
                      <Col className={'col'} sm={6} xs={12}>
                        <MDInput type="text" step="0.01" required
                                 {...register('minAmount', {
                                   valueAsDouble: true
                                 })}
                                 onChange={(e) => {
                                   let v = e.target.value.replace(/[^0-9.]/g, '');
                                   e.target.value = v;
                                   setMinAmount(v);
                                 }}
                                 InputProps={{
                                   startAdornment: <InputAdornment position="start">
                                     <span className={'fa fa-dollar'}></span>
                                   </InputAdornment>,
                                 }}
                                 placeholder={"10.00"}
                                 autoComplete="off"
                                 className="form-control" id="minAmount"
                                 label="Minimum Amount"/>
                      </Col>
                      <Col className={'col'} sm={6} xs={12}>
                        <div className={'input-group'}>
                          <MDInput type="text" step="0.01" required
                                   {...register('maxAmount', {
                                     valueAsDouble: true
                                   })}
                                   onChange={(e) => {
                                     let v = e.target.value.replace(/[^0-9.]/g, '');
                                     e.target.value = v;
                                     setMaxAmount(v);
                                   }}
                                   InputProps={{
                                     startAdornment: <InputAdornment position="start">
                                       <span className={'fa fa-dollar'}></span>
                                     </InputAdornment>,
                                   }}
                                   placeholder={"100.00"}
                                   autoComplete="off"
                                   className="form-control" id="maxAmount"
                                   label="Maximum Amount"/>
                        </div>
                      </Col>
                    </Row>
                  </>}

                  <Row className={'mt-4'}>
                    <Col className={'col'} sm={6} xs={12}>
                      <div className="form-group">
                        <div className={'input-group'}>
                          <MDInput type="number" step="1" required={!unlimited}
                                   {...register('quantity', {
                                     valueAsNumber: true,
                                   })}
                                   disabled={unlimited}
                                   defaultValue={'0'}
                                   autoComplete="off"
                                   className="form-control" id="quantity"
                                   label="Quantity"/>
                        </div>
                      </div>

                      <div className="form-group">
                        <div className={'input-group'}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                defaultChecked={eventPackage?.inventory?.unlimited}
                                {...register('unlimited')}
                                onChange={(e) => {
                                  toggleUnlimited(e);
                                }} name="unlimited"/>
                            }
                            label="Unlimited Available"
                          />
                        </div>
                      </div>

                    </Col>
                    <Col className={'col'} sm={6} xs={12}>
                      <div className="form-group native-margin-fix">
                        <label htmlFor="ageRange" className={"native-label"}>Status</label>
                        {statuses?.length && <NativeSelect
                          variant="outlined"
                          required
                          id={'status'} name={'status'} className={'form-control'}
                          {...register('status.id', {
                            valueAsNumber: true
                          })} >
                          {
                            statuses?.map((c) =>
                              <option value={c.id} key={c.id}>
                                {c.name}
                              </option>)
                          }
                        </NativeSelect>}
                      </div>


                    </Col>
                  </Row>

                  {!giftCard && <>
                    <Row className={'mt-4'}>
                      <Col className={'col'} sm={6} xs={12}>
                        <div className="form-group">
                          <div className={'input-group'}>
                            <MDInput type="text" step="0.01" required
                                     {...register('price', {
                                       valueAsDouble: true
                                     })}
                                     onChange={(e) => {
                                       let v = e.target.value.replace(/[^0-9.]/g, '');
                                       e.target.value = v;
                                       setPrice(v);
                                     }}
                                     InputProps={{
                                       startAdornment: <InputAdornment position="start">
                                         <span className={'fa fa-dollar'}></span>
                                       </InputAdornment>,
                                     }}
                                     defaultValue={'0.00'}
                                     autoComplete="off"
                                     className="form-control" id="price"
                                     label="Price"/>
                          </div>
                        </div>
                      </Col>
                      <Col className={'col'} sm={6} xs={12}>
                        <div className="form-group">
                          <div className={'input-group'}>
                            <MDInput type="text" step="0.01"
                                     {...register('wholesalePrice', {
                                       // valueAsNumber: true,
                                       valueAsDouble: true
                                     })}
                                     onChange={(e) => {
                                       let v = e.target.value.replace(/[^0-9.]/g, '');
                                       e.target.value = v;
                                       setWholesalePrice(v);
                                     }}
                                     InputProps={{
                                       startAdornment: <InputAdornment position="start">
                                         <span className={'fa fa-dollar'}></span>
                                       </InputAdornment>,
                                     }}
                                     min={0}
                                     defaultValue={'0.00'}
                                     autoComplete="off"
                                     className="form-control" id="wholesalePrice"
                                     label="Wholesale Price"/>
                          </div>
                        </div>


                      </Col>
                    </Row>
                  </>
                  }

                  <Row className={'mt-4'}>
                    <Col className={'col'} sm={6} xs={12}>
                      <div className="form-group">

                        <label htmlFor="inventoryType">Inventory Type</label>
                        {inventoryTypes?.length && <NativeSelect
                          variant="outlined"
                          required
                          id={'inventoryType'} name={'inventoryType'} className={'form-control'}
                          {...register('inventoryType.id', {
                            valueAsNumber: true
                          })} >
                          {
                            inventoryTypes?.map((c) =>
                              <option value={c.id} key={c.id}>
                                {c.name}
                              </option>)
                          }
                        </NativeSelect>}
                      </div>

                    </Col>
                    <Col className={'col'} sm={6} xs={12}>
                      <div className="form-group">

                        <label htmlFor="eventType">Event Type</label>
                        {eventTypes?.length && <NativeSelect
                          variant="outlined"
                          id={'eventType'} name={'eventType'} className={'form-control'}
                          {...register('eventType.id', {
                            valueAsNumber: true
                          })} >
                          <option value="">Event Default</option>
                          {
                            eventTypes?.map((c) =>
                              <option value={c.id} key={c.id}>
                                {c.name}
                              </option>)
                          }
                        </NativeSelect>}
                      </div>
                    </Col>
                  </Row>

                  <Row className={'mt-4'}>
                    <Col className={'col'} sm={6} xs={12}>
                      <div className="form-group">
                        <label htmlFor="brand">Brand</label>
                        {brands?.length && <NativeSelect
                          variant="outlined"
                          required
                          id={'brand'} name={'brand'} className={'form-control'}
                          {...register('brand.id', {
                            valueAsNumber: true
                          })} >
                          {
                            brands?.map((c) =>
                              <option value={c.id} key={c.id}>
                                {c.name}
                              </option>)
                          }
                        </NativeSelect>}
                      </div>
                    </Col>

                    <Col className={'col'} sm={6} xs={12}>
                      <div className="form-group">
                        <label htmlFor="inventoryImage">{inventoryLabel} Image</label>
                        <input type="file"
                               accept="image/*"
                               {...register('inventoryImage', {
                                 onChange: (e) => {
                                   handleFileChange(e);
                                 }
                               })}
                               autoComplete="off"
                               className="form-control" id="inventoryImage"/>
                        <div className={"clear clearfix"}>
                          <p className={!validImageSize ? 'pt-2 text-danger' : 'pt-2 fw-light'}>Maximum image size 5Mb
                            {!validImageSize ? ' Exceeded' : ''}</p>
                        </div>

                        {preview && <>
                          <img className={'mt-2 img-thumbnail'} src={preview} alt="img"/>
                          <Chip label="Remove"
                                style={{
                                  background: '#fff'
                                }}
                                className={'cls clear-both remove-button cursor-default'}
                                variant="outlined" onClick={() => {
                            setInventoryImage(null);
                            setValidImageSize(true);
                            removePreviewImage();
                          }}/>
                        </>}
                        {!preview && inventory?.imageUrl && removeIndex > 0 &&
                          <><img className={'mt-2 img-thumbnail'} src={inventory.imageUrl} alt="img"/>
                            <div>
                              <Chip label="Remove"
                                    style={{
                                      background: '#fff'
                                    }}
                                    className={'cls clear-both remove-button cursor-default'}
                                    variant="outlined" onClick={() => {
                                setInventoryImage(null);
                                setValidImageSize(true);
                                setRemoveIndex(0);
                                removePreviewImage();
                              }}/>
                            </div>
                          </>}
                      </div>
                    </Col>
                  </Row>

                  <Row className={'mt-2'}>
                    <Col className={'col'} sm={12} xs={12}>
                      <div className="form-group">
                        <label htmlFor="name">{inventoryLabel} Description</label>
                        <textarea type="text"
                                  rows={8}
                                  {...register('desc')}
                                  autoComplete="off"
                                  maxLength={4000}
                                  className="form-control" id="desc"
                                  placeholder={'Enter ' + inventoryLabel + ' Description'}/>
                      </div>
                    </Col>
                  </Row>


                  <Divider/>
                  <Row className={'mt-2'}>
                    <Col className={'col'} sm={12} xs={12}>

                      <Row>

                        <Col className={'col'} sm={6} xs={12}>
                          <h6>Available Items</h6>
                          <ul className={'list-group'}>
                            {availableInventories?.length > 0 && availableInventories?.sort((a, b) => b.id - a.id).map((inventory, index) => {
                              return (
                                <li index={index} key={index}
                                    className={'list-group-item'}>
                                  <Avatar alt={inventory.name}
                                          className={'pull-left mr-2'}
                                          sx={{width: 32, height: 32}}>
                                    <img src={inventory.imageUrl}
                                         style={{width: '200%', height: 'auto'}}
                                         alt={inventory.name}/>
                                  </Avatar> &nbsp;{inventory.name}
                                  <IconButton aria-label="Add" className={'pull-right mt-n1'} onClick={() => {
                                    assignInventory(inventory);
                                  }}>
                                    <Icon>add_circle</Icon>
                                  </IconButton>
                                </li>
                              )
                            })
                            }
                          </ul>
                        </Col>

                        <Col className={'col'} sm={6} xs={12}>

                          <h6>Assigned Items {packagePrice > 0 && <>(cost: {formatCurrency(packagePrice)})</>}</h6>
                          <ul className={'list-group'}>
                            {assignedInventories?.map((inventory, index) => {
                              return (
                                <li key={index} className={'list-group-item'}>
                                  <label>Package Included
                                    <Checkbox checked={inventory?.included}
                                              onChange={(e) => {
                                                updateItem(inventory, e.target.checked)
                                              }}
                                    />
                                  </label>
                                  <Chip
                                    className={'m-1'}
                                    avatar={<Avatar src={inventory.imageThumbUrl || inventory.imageUrl}/>}
                                    label={inventory.name}
                                    onDelete={() => {
                                      handleRemoveItem(inventory)
                                    }}
                                    variant="outlined"
                                    color="secondary"/>
                                </li>
                              )
                            })
                            }
                          </ul>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Container>
              </Col>
            </Row>

          </Modal.Body>
          <Modal.Footer>
            <MDButton type="submit" color="info" disabled={formInvalid || saving}>
              {saving ? 'Saving...' : 'Save'}
            </MDButton>
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
}